<template>
    <div class="overlay-foreground position-absolute fill opaque px-5" v-if="shown && dropdowns">
        <div v-if="products.length">
            <div :class="listTitleClass" v-if="hits.product">In products:</div>
            <div :class="listTitleClass" v-else>Did you mean:</div>
            <div :class="listItemClass" v-for="(product, key) in products" :key="key">
                <a @mousedown="search($event)" :data_value="product.name" v-html="product.html"></a>
            </div>
        </div>

        <div v-if="brands.length">
            <div :class="listTitleClass">In brands:</div>
            <div :class="listItemClass" v-for="(brand, key) in brands" :key="key">
                <a @mousedown="listing($event)" :data_id="brand.id" :data_type="brand.type" :data_name="brand.name" v-html="brand.html"></a>
            </div>
        </div>

        <div v-if="cats.length">
            <div :class="listTitleClass">In categories:</div>
            <div :class="listItemClass" v-for="(cat, key) in cats" :key="key">
                <a @mousedown="listing($event)" :data_id="cat.id" :data_type="cat.type" :data_name="cat.name" v-html="cat.html"></a>
            </div>
        </div>
    </div>
</template>

<script>
    import searchMixin from './searchMixin'

    export default {
        mixins: [searchMixin],

        props: ["shown"],

        computed: {
            dropdowns: function () {
                return this.products.length || this.brands.length || this.cats.length
            },
            hits: function() {
                return this.$store.state.hits
            },
            products: function() {
                if(this.$store.state.brands.length || this.$store.state.cats.length)
                    return this.$store.state.products.slice(0,3)

                return this.$store.state.products
            },
            brands: function() {
                if(this.$store.state.products.length || this.$store.state.cats.length)
                    return this.$store.state.brands.slice(0,3)

                return this.$store.state.brands
            },
            cats: function() {
                if(this.$store.state.products.length || this.$store.state.brands.length)
                    return this.$store.state.cats.slice(0,3)

                return this.$store.state.cats
            },
            listTitleClass: function() {
                return 'font-sm text-gray-dk mb-3';
            },
            listItemClass: function() {
                return 'font-md mb-4';
            }
        },
        methods: {
            capitalize(str) {
                return _.startCase(_.toLower(str))
            },
        }
    }
</script>